import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { AdminService } from './admin.service';
import { CoreService } from '../core/core.service';
import { Router } from '@angular/router';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})

export class CustomersComponent {

  filter: string;
  enrollmentOption: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  profiles: any[];
  ekubs: any[];
  branches: any = [];
  userEkub: any;
  userEkubForm!: FormGroup;

  selectedUser: any = {};
  imageUrl: any;
  selectedProfileUrl: any;
  selectedLegalIdUrl: any;
  baseUrl: string = environment.production
    ? environment.ONLINE_BASE_URL :
    environment.LOCAL_BASE_URL;

  constructor(private api: AdminService, private router: Router, private formBuilder: FormBuilder, private sanitizer: DomSanitizer, private coreService: CoreService, private mainService: Main, @Inject(Restangular) public Restangular) {
    this.filter = '';
    this.enrollmentOption = '';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.userEkub = {};
    this.getProfileFilter('');
  }

  get user() { return this.userEkubForm.get('user'); }
  get ekub() { return this.userEkubForm.get('ekub'); }
  get branch() { return this.userEkubForm.get('branch'); }
  get status() { return this.userEkubForm.get('status'); }
  get remark() { return this.userEkubForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    this.getAllEkubs();
    this.getBranches();
  }

  private createForm() {

    this.userEkubForm = this.formBuilder.group({
      user: ['', [Validators.required,]],
      ekub: ['', [Validators.required,]],
      branch: ['', [Validators.required]],
      status: ['pending', Validators.required],
      remark: [''],
    });
  }

  getAllEkubs() {
    debugger;
    this.api.getAllEkubs('').subscribe((res: any) => {
      debugger;
      this.ekubs = res.data;
      for (let ekub of this.ekubs) {
        ekub.text = ekub.ekub_id;
        ekub.id = ekub.id;
      }
    });
  }

  getProfileFilter(filter: any) {
    this.filter = filter;
    this.getProfiles();
  }

  setUser(profile: any) {
    //?.user.data.id
    debugger;
    this.selectedUser = profile.user.data;
  }

  addEnrollement() {
    debugger;
    this.enrollmentOption = '?second=true';
    this.enrollUser();
  }

  enrollUser() {
    debugger;
    var dto = {
      "ekub": this.ekub.value,
      "member": this.selectedUser.id,
      "branch_id": this.branch.value,
      "status": this.status.value,
      "remark": this.remark.value
    };
    this.api.enrollUser(dto, this.enrollmentOption).subscribe((res: any) => {
      debugger;
      if (res.code && res.code == 'CONFENR') {
        this.mainService.toast({ title: 'Warning', body: res.title, type: 'warning' });
        document.getElementById('openModal').click();
        return;
      }
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'success' });
    }, (err: any) => {
      debugger;
      //this.mainService.addToast('Error', err.statusText);
      this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
    });
  }

  getProfiles() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getProfiles(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.profiles = resp.data;
      for (let i = 0; i < this.profiles.length; i++) {
        this.profiles[i].imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.profiles[i].avatar}`);
        this.profiles[i].legalIdUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.profiles[i].legal_id}`);
        this.profiles[i].no = j + 1;
        j++;
      }
      console.log(this.profiles);
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    });
  }


  getBranches() {
    var filter = '?all=true';
    this.api.getBranches(filter).subscribe((resp: any) => {
      debugger;
      this.branches = resp.data;
      this.branches.forEach(element => {
        element.text = element.name + ' - ' + element.city;
      });
    }, (err: any) => {
      debugger;
      this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
    });
  }

  /*   enrollUser() {
      debugger;
      var dto = {
        "ekub": this.ekub.value,
        "member": this.selectedUser.id,
        "status": this.status.value,
        "remark": this.remark.value
      };
      this.api.enrollUser(dto).subscribe((res: any) => {
        debugger;
        this.mainService.toast({ title: 'Success', body: res.data.title, type: 'success' });
      }, (err: any) => {
        debugger;
        //this.mainService.addToast('Error', err.statusText);
        this.mainService.toast({ title: 'Error', body: err.data, type: 'danger' });
      });
    } */

  setProfile(user: any) {
    debugger;
    this.selectedUser = user;

  }

  setProfileUrl(profile: any = null, legalId: String = null) {
    debugger;
    if (profile != null) this.selectedProfileUrl = profile;
    if (legalId != null) this.selectedLegalIdUrl = legalId;
  }

  changeStatus(id: any, status: any) {
    this.api.changeProfileStatus(id, status).subscribe((res: any) => {
      debugger;
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getProfiles();
    }, (err: any) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getProfiles();
  }

}
